<div class="flex flex-wrap space-between bottom-spacer" *ngIf="!showMobileFilters || !utilService.isMobile">
  <div class="heading-1">{{'general.api_menu_templates' | translate}}</div>
  <div>
    <button mat-stroked-button color="primary" (click)="create()">
      {{ 'general.api_templates_create_new' | translate }}
    </button>
  </div>
</div>
<form #searchForm="ngForm" class="filter no-print" (ngSubmit)="isFormValid && search()"
      [ngClass]="{'no-border': utilService.isMobile && showMobileFilters}">
  <div class="filter-overlay" *ngIf="isLoading">&nbsp;</div>
  <div class="flex space-between" *ngIf="utilService.isMobile && showMobileFilters">
    <span class="heading-2 break-word">{{ 'general.api_templates_filters' | translate }}</span>
    <div class="align-right">
      <button mat-button class="icon-button" (click)="toggleFilters()">
        <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-column-mobile flex-wrap flex-filters bottom-spacer">
    <!-- Key -->
    <div class="flex">
      <app-text-input [label]="'general.api_templates_table_key'" [(value)]="filters.key"
                      [withSuffix]="utilService.isMobile && !showMobileFilters" class="mobile-max-width">
        <button mat-button class="icon-button input-button suffix-button" type="submit">
          <mat-icon class="svg-icon" [svgIcon]="'search'"></mat-icon>
        </button>
      </app-text-input>
      <div class="no-min-width" *ngIf="utilService.isMobile && !showMobileFilters">
        <button type="button" mat-button class="icon-button input-button" (click)="toggleFilters()">
          <mat-icon class="svg-icon" [svgIcon]="'filters'"></mat-icon>
        </button>
      </div>
    </div>
    <!-- Other fields template -->
    <div *ngIf="utilService.isMobile && showMobileFilters" class="flex flex-column-mobile">
      <ng-container [ngTemplateOutlet]="extraFields"></ng-container>
    </div>
    <ng-container *ngIf="!utilService.isMobile" [ngTemplateOutlet]="extraFields"></ng-container>    
  </div>
</form>
<ng-container *ngIf="!utilService.isMobile || !showMobileFilters">
  <div class="heading-2">{{ 'general.api_search_results' | translate }}</div>
  <div class="body-2 text-muted" *ngIf="!isLoading && !resultsKeys.length">
    <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
    {{ 'general.api_templates_empty' | translate }}
  </div>
  <mat-card appearance="outlined" *ngIf="!isLoading && resultsKeys.length">
    <div class="flex space-between flex-column-mobile bottom-spacer">
      <div class="flex">
        <mat-form-field class="dynamic-width">
          <mat-label>{{'general.api_search_display' | translate}}:</mat-label>
          <mat-select [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalStorage(); search()">
            <mat-select-trigger>{{pageSize}}</mat-select-trigger>
            <mat-option *ngFor="let pageSizeValue of pageSizeOptions" [value]="pageSizeValue">
              {{pageSizeValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Languages -->
      <mat-form-field appearance="outline" class="no-hint">
        <mat-label>{{ 'general.api_translations_table_languages' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedLanguages" [ngModelOptions]="{standalone: true}" (selectionChange)="updateLocalStorage()" multiple>
          <mat-option *ngFor="let language of sortedLanguages" [value]="language"
                      [disabled]="selectedLanguages.length === 3 && selectedLanguages.indexOf(language) === -1">
            {{ 'general.api_translations_table_lang_' + language | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <hr class="slim mobile">
    <div class="mobile">
      <div class="listing-block" *ngFor="let key of resultsKeys; let last = last" [ngClass]="{'last-block': last}">
        <div class="header-block flex flex-grow bottom-spacer">
          <div>
            <a class="heading-5 no-margin break-word link bold" (click)="$event.stopPropagation(); edit(key)">{{ key }}</a>
            <span class="text-muted">{{'general.api_templates_table_key' | translate}}</span>
          </div>
          <div class="white-space-no-wrap no-grow no-min-width">
            <button mat-button class="icon-button input-button" [matMenuTriggerFor]="actionMenu">
              <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
              <button mat-menu-item (click)="view(key)">
                <mat-icon class="svg-icon" [svgIcon]="'eye'"></mat-icon>
                <span>{{'general.api_templates_table_preview' | translate}}</span>
              </button>
              <button mat-menu-item (click)="edit(key)">
                <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                <span>{{'general.api_templates_table_edit' | translate}}</span>
              </button>
              <button mat-menu-item (click)="confirmDelete(key)">
                <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                <span>{{'general.api_templates_table_delete' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <table class="mobile-max-width bottom-spacer">
          <tbody>
          <tr *ngFor="let language of selectedLanguages">
            <td class="medium break-word">{{ 'general.api_translations_table_lang_' + language | translate }}</td>
            <td class="align-right">
              {{ results.items[key][language]?.substring(0, 40) }}<ng-container *ngIf="results.items[key][language]?.length > 40">...</ng-container>
            </td>
          </tr>
          </tbody>
        </table>
        <hr class="no-margin">
      </div>
    </div>
    <table class="report-table desktop">
      <thead>
        <tr>
          <th class="quarter-width">{{ 'general.api_templates_table_key' | translate }}</th>
          <th *ngFor="let language of selectedLanguages">{{ 'general.api_translations_table_lang_' + language | translate }}</th>
          <th class="min-width">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let key of resultsKeys">
          <td><a class="link" (click)="$event.stopPropagation(); edit(key)"><span>{{ key }}</span></a></td>
          <td *ngFor="let language of selectedLanguages">
            {{ results.items[key][language]?.substring(0, 40) }}<ng-container *ngIf="results.items[key][language]?.length > 40">...</ng-container>
          </td>
          <td class="align-right white-space-no-wrap">
            <button mat-button class="left-spacer icon-button input-button" (click)="view(key)">
              <mat-icon class="svg-icon" [svgIcon]="'eye'"></mat-icon>
            </button>
            <button mat-button class="left-spacer icon-button input-button" (click)="edit(key)">
              <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
            </button>
            <button mat-button class="left-spacer icon-button input-button" (click)="confirmDelete(key)">
              <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <app-pagination [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)"></app-pagination>
  </mat-card>
</ng-container>
<app-loader [loading]="isLoading"></app-loader>
<ng-template #extraFields>
  <!-- Word -->
  <app-text-input [label]="'general.api_templates_table_word'" [(value)]="filters.word"></app-text-input>
  <!-- Last updated start and end date -->
  <app-datepicker [(dateStart)]="filters.startDate" [(dateEnd)]="filters.endDate"
                  [datePickerConfig]="{autoBindDates: true, range: true, label: 'general.api_translations_list_date', maxDate: maxDate, noHint: true}" />
  <!-- Untranslated language -->
  <mat-form-field appearance="outline" class="no-hint">
    <mat-label>{{ 'general.api_translations_table_untranslated_language' | translate }}</mat-label>
    <mat-select [(ngModel)]="filters.untranslatedLanguage" [ngModelOptions]="{standalone: true}">
      <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
      <mat-option *ngFor="let language of sortedLanguages" [value]="language">
        {{ 'general.api_translations_table_lang_' + language | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- Desktop actions -->
  <div *ngIf="!utilService.isMobile" class="flex flex-column-reverse-mobile">
    <button mat-button type="button" (click)="clearFilters()">
      {{ 'general.api_templates_clear' | translate }}
    </button>
    <button mat-flat-button type="submit" color="primary">
      {{ 'general.api_templates_search' | translate }}
    </button>
  </div>
  <!-- Mobile actions/footer -->
  <footer *ngIf="utilService.isMobile && showMobileFilters" class="mobile">
    <mat-dialog-actions>
      <button mat-button (click)="clearFilters()" type="button">
        <span>{{ 'general.api_templates_clear' | translate }}</span>
      </button>
      <button mat-flat-button color="primary" type="submit">
        <span>{{ 'general.api_templates_search' | translate }}</span>
      </button>
    </mat-dialog-actions>
  </footer>
</ng-template>
